import React from 'react';
import FeedbackTitleUnderline from './FeedbackTitleUnderline';
import { FeedbackTitle, FeedbackTitleHighlight, FeedbackTitleUnderlineWrap } from './styles';

const FEEDBACK_TITLE = 'Have feedback or questions?';

const FeedbackTitleContent: React.FC = () => {
  const words = FEEDBACK_TITLE.trim().split(/\s+/);
  const leadingWords = words.slice(0, -1).join(' ');
  const lastWord = words[words.length - 1];

  return (
    <FeedbackTitle>
      {leadingWords}{' '}
      <FeedbackTitleHighlight>
        {lastWord}
        <FeedbackTitleUnderlineWrap>
          <FeedbackTitleUnderline />
        </FeedbackTitleUnderlineWrap>
      </FeedbackTitleHighlight>
    </FeedbackTitle>
  );
};

export default FeedbackTitleContent;
